var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-card',{staticClass:"eff-item mb-3 py-3 px-2",attrs:{"align":"center","no-body":""}},[_c('b-card-text',{staticClass:"mb-0 eff-item-title"},[_vm._v(_vm._s(_vm.title)+" Efficiency")]),_c('b-card-text',{staticClass:"mb-0 eff-item-value"},[_vm._v(_vm._s(_vm.utils.bigToCommon(_vm.value, 18, 2)))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }